import { render, staticRenderFns } from "./sucessDialog.vue?vue&type=template&id=629979ea&scoped=true"
import script from "./sucessDialog.vue?vue&type=script&lang=js"
export * from "./sucessDialog.vue?vue&type=script&lang=js"
import style0 from "./sucessDialog.vue?vue&type=style&index=0&id=629979ea&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629979ea",
  null
  
)

export default component.exports